import { CurrentVisitViewQuery, VisitView } from '@dreryk/egabinet-dashboard-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';

type ConfirmedAppointmentsRenderProps = {
   visitsView: VisitView[];
};

type ConfirmedAppointmentsLoaderProps = {
   readonly children: (renderProps: ConfirmedAppointmentsRenderProps) => JSX.Element;
};

export const ConfirmedAppointmentsLoader = (props: ConfirmedAppointmentsLoaderProps): JSX.Element => {
   const { data: visitsView, loading: visitsViewLoading, error: visitsViewError } = useCqrsSearch<VisitView>(
      () => new CurrentVisitViewQuery()
   );

   if (visitsViewLoading) {
      return <LoaderSpinner />;
   }

   if (visitsViewError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={dashboardTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      visitsView: visitsView,
   });
};
